import { apiClient } from "@/lib/api-client";

export const getExport70New = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number | string;
  semester: number | string;
  periodeID: string | number;
}) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    periodeID: periodeID.toString(),
  });

  const res = await apiClient<any>(
    `${baseUrl}/api/v1/dosen-remun/export-70-new/${niu}?${params.toString()}`,
    {
      method: "GET",
    },
  );

  return res.data;
};
